import PrivateRoute from "./PrivateRoute";
import Login from "../pages/Login";
import Signup from "../pages/Signup/Signup";
import Account from "../pages/Account";
import React from "react";
import { Route, Switch } from "react-router-dom";
import Home from "../pages/Home";
import ForgotPassword from "../pages/Account/components/ForgotPassword/ForgotPassword";
import Products from "../pages/Products";
import Gallery from "../pages/Gallery";
import Arrays from "../pages/Arrays";
import FormProductPay from "../pages/FormProductPay";
import Blog from "../pages/Blog";
import New from "../pages/New";
import ProductPay from "../pages/ProductPay/ProductPay";
import Checkout from "../pages/Checkout";
import Faqs from "../pages/Faqs";
import Purchases from "../pages/Purchases";
import News from "../pages/News.js";
import Error404 from "../pages/Error404";
import ResponseAction from "../pages/ResponseAction";
import { daysRestriction } from "./../commons/helpers/daysRestriction";

const Routes = () => (
  <Switch>
    <Route exact path="/login" component={Login} />
    <Route exact path="/signup" component={Signup} />
    <Route exact path="/" component={Home} />
    <Route exact path="/forgotPassword" component={ForgotPassword} />
    <Route exact path="/products/:type/:page?" component={Products} />
    <Route exact path="/product/:id?" component={ProductPay} />
    <Route exact path="/gallery" component={Gallery} />
    <Route exact path="/arrays" component={Arrays} />
    <Route exact path="/blog" component={Blog} />
    <Route exact path="/blog/new" component={New} />
    <Route exact path="/faqs" component={Faqs} />
    <Route exact path="/purchases" component={Purchases} />
    <Route exact path="/form_card_product" component={FormProductPay} />
    <Route exact path="/News/:id" component={News} />
    {!daysRestriction() && (
      <>
        <Route exact path="/checkout" component={Checkout} />
        <Route exact path="/checkout/result/*" component={ResponseAction} />
      </>
    )}
    <PrivateRoute exact path="/account" component={Account} />
    <Route exact path="/*" component={Error404} />
  </Switch>
);

export default Routes;
